<template>
  <div>
    <Sidebar />
    <div class="h-screen" :style="{ 'margin-left': sidebarWidth }">
      <div class="grid grid-cols-5">
        <div class="col-span-5 h-12 p-2 bg-gray-500">
          <p class="float-left ml-4 text-2xl text-white">Scan Data</p>
        </div>
        <div class="col-span-3"></div>
        <div class="col-span-2">
          <!-- <input type="file" @change="onFileChange"/> -->
          <button class="bg-button hover:bg-button3 text-black hover:text-white disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 text-base py-2 px-4 mr-10 mt-6 float-right rounded" @click.prevent="Focus()">Scan BarCode</button>
          <button class="bg-button hover:bg-button3 text-black hover:text-white disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 text-base py-2 px-4 mr-2 mt-6 float-right rounded" @click.prevent="modalBag2 = true">Scan QrCode</button>
        </div>
        <div class="col-span-5">
          <template v-if="valueS == true">
            <p class="text-2xl">{{ data.uniqueId }}</p>
            <p class="text-2xl">{{ data.name }}</p>
            <p class="text-2xl">{{ data.copy }}</p>
          </template>
          <template v-else>
            <p class="text-2xl">No Data</p>
          </template>
        </div>
      </div>
    </div>

    <div v-if="modalBag" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    <div v-if="modalBag" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-auto my-6 mx-auto max-w-[800px] h-[700px]">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex justify-center p-5 border-b border-solid border-slate-200 rounded-t">
            <h3 class="text-2xl font-semibold">Scan</h3>
          </div>
          <!--body-->
          <div class="w-[700px] h-48">
            <p class="text-xl">Scanning...</p>
            <input ref="app" autofocus v-model="barcodeValue" type="text" style="all: unset; caret-color: transparent" />{{ gg }}
          </div>
          <!--footer-->
          <div class="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
            <button class="text-red-500 bg-transparent border border-solid border-red-500 hover:bg-red-500 hover:text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" @click.prevent="(this.modalBag = false), (barcodeValue = '')">Close</button>
            <button class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" @click.prevent="BagSave()">Save Changes</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modalBag2" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    <div v-if="modalBag2" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-auto my-6 mx-auto max-w-[800px] h-[700px]">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex justify-center p-5 border-b border-solid border-slate-200 rounded-t">
            <h3 class="text-2xl font-semibold">Scan</h3>
          </div>
          <!--body-->
          <div class="w-[700px] h-[500px]">
            <qrcode-stream class="h-fit w-fit p-4" @decode="onDecode"></qrcode-stream>
          </div>
          <p>{{ barcodeValue }}</p>
          <!--footer-->
          <div class="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
            <button class="text-red-500 bg-transparent border border-solid border-red-500 hover:bg-red-500 hover:text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" @click.prevent="(this.modalBag2 = false), (barcodeValue = '')">Close</button>
            <button class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" @click.prevent="">Save Changes</button>
          </div>
        </div>
      </div>
    </div>

    <NotificationGroup group="foo">
      <div class="fixed inset-0 flex items-start justify-end px-4 py-6 mt-[85vh] pointer-events-none">
        <div class="w-full max-w-sm">
          <Notification v-slot="{ notifications }" enter="transform ease-out duration-300 transition" enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4" enter-to="translate-y-0 opacity-100 sm:translate-x-0" leave="transition ease-in duration-500" leave-from="opacity-100" leave-to="opacity-0" move="transition duration-500" move-delay="delay-300">
            <div class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md" v-for="notification in notifications" :key="notification.id">
              <div class="flex items-center justify-center w-12 bg-AccentCustomer">
                <svg class="w-6 h-6 text-white fill-current" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" />
                </svg>
              </div>

              <div class="px-4 py-2 -mx-3">
                <div class="mx-3">
                  <span class="font-semibold text-AccentCustomer">{{ notification.title }}</span>
                  <p class="text-sm text-gray-600">{{ notification.text }}</p>
                </div>
              </div>
            </div>
          </Notification>
        </div>
      </div>
    </NotificationGroup>
  </div>
</template>
<script>
import Sidebar from '@/components/sidebar/Sidebar';
import { sidebarWidth } from '../components/sidebar/state';
import api from '../../boot/axios.js';
import VueBarcode from '@chenfengyuan/vue-barcode';
import { notify } from 'notiwind';
import { QrcodeStream } from 'vue3-qrcode-reader';

export default {
  components: {
    Sidebar,
    barcode: VueBarcode,
    QrcodeStream,
  },
  setup() {
    return { sidebarWidth };
  },
  data() {
    return {
      modalBag: false,
      modalBag2: false,
      barcodeValue: '',
      data: [],
      valueS: false,
    };
  },
  computed: {
    gg() {
      if (this.barcodeValue.length == 6) {
        this.getData();
      }
    },
  },
  created() {},
  methods: {
    onDecode(decodedString) {
      this.barcodeValue = decodedString;
      console.log(this.decodedString);
      // this.gg();
    },
    async getData() {
      this.valueS = false;
      await api
        .get(`api/product_filter/?uniqueId=${this.barcodeValue}`)
        .then((response) => {
          this.data = response.data[0];
        })
        .catch((error) => {
          console.log(error);
        });
      this.barcodeValue = '';
      if (typeof this.data === 'undefined') {
        this.Toast();
        this.data = [];
        this.modalBag = false;
        this.modalBag2 = false;
      } else {
        this.valueS = true;
        console.log(this.data);
        this.modalBag = false;
        this.modalBag2 = false;
      }
    },
    Focus() {
      this.modalBag = true;
      this.FocusOnEditButton();
    },
    FocusOnEditButton() {
      this.$nextTick(() => {
        const editButtonRef = this.$refs.app;
        editButtonRef.focus();
      });
    },

    Toast() {
      notify(
        {
          group: 'foo',
          title: 'No Data Found',
          text: 'No Such data in database',
        },
        1500
      );
    },
  },
};
</script>